module.exports = __webpack_public_path__ + "step4.ee3fdeef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/old steps/step4.png
// module id = Fq9J
// module chunks = 0